import React, { useEffect, useState } from 'react'
import ComposeEmail from '../../../components/EmailSection/ComposeEmail'
import { Dropdown as AntDropdown, Spin, Tooltip } from 'antd';
import { Button, Col, Row } from 'reactstrap';
import Config from '../../../config.json'
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTimes } from '@fortawesome/free-solid-svg-icons'; 
import { v4 as uuid } from 'uuid';
import EmailSchedular from '../../../components/EmailSection/EmailSchedular';
import dayjs from 'dayjs';
import { faFile, faFileExcel, faFileImage, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import PreviewAndDownload from '../../../components/EmailSection/PreviewAndDownload';
import EmailService from '../../../common/util/EmailService';
import Loader from '../../../common/loader';
import moment from 'moment';
import AwsServerService from '../../../common/util/AwsServerService';
import _ from 'lodash';

export default function EmailMimic({ clickedFromBody, location, handleNotificationHyperlink, task, 
    viewTaskData, allUsers, cacheDeals, refreshEnable, setRefreshEnable, getParams, dealObj, fromtask,
    setEmailData,setEmailsInfo,emailsInfo,setEamilsInfo,setComposePopup
}) {
    let userinfo = JSON.parse(localStorage.getItem('userinfo'));
    let AccountID = localStorage.getItem('AccountID');
    const [emailContent, setEmailContent] = useState(''); 
  const [attachments, setAttachments] = useState([]);
  const [emailAttachmentInfo,setEmailAttachmentInfo]=useState([]);
  const [contentShowFlag, setContentShowFlag] = useState("");
  const [viewEmail, setViewEmail] = useState(null)
  const [attachementLoader, setAttachmentLoader] = useState(false)
  const [replyEmail, setReplyEmail] = useState(false);
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [loader, setLoader] = useState(false); 
   const [isDraftAlready, setIsDraftAlready] = useState(false); 
   const [composeMailObj, setComposeMailObj] = useState({
      from: [{email:task?.TaskFlowObject?.BotAccountEmail,id:0}],
      to: [],
      cc: [],
      bcc: [],
      subject: "",
    })
    const [signature, setSignature] = useState("");
    const [draftEmailContent, setDraftEmailContent] = useState("");
    const [openSchedulePopup, setOpenSchedulePopup] = useState(false);
      const [composeMailToShow, setComposeMailToShow] = useState({
        from: "",
        to: [],
        cc: [],
        bcc: [],
        subject: "",
      })
  const [composeObj, setComposeObj] = useState({ fromAddress: userinfo?.email_id, askReceipt: 'yes' })  
  useEffect(()=>{ 
    setContentShowFlag(emailsInfo.Action)
    if(emailsInfo.Action=='compose'||emailsInfo.Action==""){
      setEmailAttachmentInfo([])
      setAttachments([])
      setComposeMailObj({from: [{email:task?.TaskFlowObject?.BotAccountEmail,id:0}],to: [],cc: [],bcc: [],subject: "",}) 
      setComposeMailToShow({from: task?.TaskFlowObject?.BotAccountEmail,to: [],cc: [],bcc: [],subject: "",}) 
      setDraftEmailContent("")
      // setEmailContent('');
      setViewEmail(null);
    }else{
      setViewEmail(emailsInfo.Email);
      let email=emailsInfo.Email;
      if(email.accountMail && email.attachmentsInfo && email.attachmentsInfo.length > 0){
         setAttachmentLoader(true);
         let arry=[];
         Promise.all(email.attachmentsInfo.map(e=>EmailService.GetAttachmentsContent(email.accountId,email.folderId,email.messageId,e.attachmentId,email.token).then(res=>{
          arry.push({
            attachmentName: e.attachmentName, 
            size: e.attachmentSize,
            attachmentId:e.attachmentId,
            compressedBase64: res})
         }))).then(r=>{
          setAttachmentLoader(false);
          setEmailAttachmentInfo(arry)
          setViewEmail({...emailsInfo.Email,attachments:arry});
        }).catch(er=>setAttachmentLoader(false))
      }
      setEmailAttachmentInfo(email.attachments)
      setComposeMailObj({from:email.from,to:email.to,cc:email.cc,bcc:email.bcc,subject:email.subject});
      setComposeMailToShow({from:email.from?.map(e=>e.email).join('; '),to:email.to,cc:email.cc,bcc:email.bcc,subject:email.subject});
      setDraftEmailContent(email.body);
      // setEmailContent(email.body);
    } 
  },[emailsInfo.Action,emailsInfo.Email])
  const getIconByType=(name)=>{
        if(name.includes("pdf")){
          return <FontAwesomeIcon color='#007bff' icon={faFilePdf} />
        }else if(name.includes("xlx")){
          return <FontAwesomeIcon icon={faFileExcel} />
        }else if(name.includes("png") || name.includes("jpeg")){
          return <FontAwesomeIcon color='#007bff' icon={faFileImage} />
        }else{
          return <FontAwesomeIcon color='#007bff' icon={faFile} />
        }
      }
      const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);  
          fileReader.onload = () => {
            const base64 = fileReader.result.split(',')[1];  
            resolve(base64);
          };
          fileReader.onerror = (error) => reject(error);
        });
      };
      
   const handleFileAttachments = async (fileList) => { 
       let tempFileCollection = [...attachments]; 
       let v = fileList.length;
       let index = 0;
       while (index < v) {
         let fileName = fileList[index].name; 
         tempFileCollection.push({
           attachmentId:uuid(),
           attachmentName:fileName,
           file: fileList[index],
         });
         index = index + 1;
       }
       setAttachments(tempFileCollection); 
     };
     const getCCOptions = () =>{
        const items = [
          {
            label: <a
              onClick={() => {
                setShowCC(!showCC)
              }}
            >
              {showCC ? "Hide CC" : "Show CC"}
              </a>,
            key: "0",
          },
          {
            label: <a
            onClick={() => {
              setShowBCC(!showBCC)
            }}
          >
            {showBCC ? "Hide BCC" : "Show BCC"}
          </a>,
            key: "1",
          },
        
        ];
        return (
          <AntDropdown
            className="email-setting-icon"
            overlayStyle={{zIndex:9999}}
            menu={{
              items,
            }}
            arrow={{
              pointAtCenter: true,
            }}
            trigger={["click"]}
          >
            <Button
              className="Action-Btn-Ant"
              variant="outline-primary"
              onClick={(e) => e.preventDefault()}
            >
              <FontAwesomeIcon
                className="Action-Btn-Ant-Dropdown"
                icon={faCog}
                style={{ marginRight: "12px" }}
              />
            </Button>
          </AntDropdown>
        )
      }
      const handleReplyEmailFromAccount = async (obj, type, taskROWID) =>{
        await UploadAttachments(attachments).then(res=>{
          if(res.length>0){
            obj["attachments"]=res.map(k=>{delete k.url; return k});
          }
        }).catch(e=>{
          console.log(e);
        })
        if (AccountID) {
          obj.action = 'reply'
          EmailService.ReplyToEmail(AccountID, viewEmail?.messageId, obj)
            .then(async (result) => { 
             let dataObj={TaskROWID:taskROWID,TaskType:type,MessageID:result.data.messageId,EmailAddress:obj.fromAddress};
              EmailService.saveAutomationManangerRecord(dataObj).then(res=>{
                setLoader(false); 
                setAttachments([]);
              })
              let task=createBreadCrumbFromTask(viewTaskData);
                  await EmailService.AssociateEmailWithRecords({
                    messageId:result.data.messageId,
                  AssociationType:"Manual",
                  AssociationObj:{Tasks:[task]}
                },"Post").then(res=>{ 
                  swal("Success!", "Email associated successfully!", "success");
                }).catch(e=>{ 
                  swal("Error!", "Something went wrong while associating email with task!", "error");
                })
                setComposePopup(false);
            })
            .catch((err) => {
              setAttachments([])
              console.log(err);
            })
        }
      }
      
      const handleReplyEmail = async (data, type, taskROWID) =>{ 
        const uploadPromises = attachments.map(file => customUploadAction(file.file, type, taskROWID));
        const uploadedLinks = await Promise.all(uploadPromises); 
        let messageData = emailsInfo.Email;
        let messageIdToReply = messageData?.messageId || "";            
        let existingReferences = messageData?.references || "";          
        let InReplyTo = messageIdToReply;        
        let References = "";
        if (existingReferences) {
          References = `${existingReferences} ${messageIdToReply}`.trim();
        } else {
          References = messageIdToReply;
        } 
         
        let obj = {
          fromAddress:data.fromAddress,
          askReceipt: data.askReceipt,
          attachments: uploadedLinks, 
          bccAddress: data.bccAddress,
          ccAddress: data.ccAddress,
          content: data.content,
          mailFormat: "html",
          subject: data.subject,
          toAddress: data.toAddress, 
          taskType:type,
          token:localStorage.getItem('token'),
          backendUrl:Config.backend_url,
          taskROWID:taskROWID,
          InReplyTo:InReplyTo,
          References:References
        };
        setLoader(true);
        EmailService.SendEmailFromTasks(obj).then(res=>{
          setLoader(false);
          setRefreshEnable(true);
          setComposePopup(false);
        }).catch(err=>{
          setLoader(false)
        })
      }
      const customUploadAction = async (file, type, id) => {
        let path = ["Automation", "Documents", `${type}_${id}`];
        let FileName = file.name;
        let name = `${type}_${id}_${Date.now()}_${file.name}`; 
        file = new File([file], name, {
            type: file.type,
            lastModified: file.lastModified,
        });
        file.uid = uuid(); 
        try {
            const parentFolderId = await AwsServerService.ensureFolderPathExists(dealObj?.zohoworkdriveforcrm__Workdrive_Folder_ID,path,localStorage.getItem('token')); 
            if (!parentFolderId) throw new Error('Upload failed');
            const res = await AwsServerService.UploadFileWorkDrive(file,parentFolderId,localStorage.getItem('token'));
            const link = `${FileName}___${res?.data?.data[0]?.attributes?.resource_id}`;
            return link;
        } catch (error) {
            console.error('Upload failed:', error);
            throw error;
        } finally {
            setLoader(null);
        }
    };
    const UploadAttachments=async(files)=>{
        return new Promise(async(resolve,reject)=>{
          const results = await Promise.all(files.map(file => EmailService.UploadEmailAttachement(AccountID, file.file)));
          const allData = results.reduce((acc, result) => acc.concat(result.data), []); 
          resolve(allData);
        })
      }
      function createBreadCrumbFromTask(pipeline) {
        const dealName = pipeline?.Pipeline.DealName;
        const PipelineName = pipeline?.Pipeline.PipelineName;
        const pipelineROWID = pipeline?.Pipeline.PipelineROWID;
        const taskROWID = pipeline?.Task.TaskROWID; 
        const taskName = pipeline?.Task.TaskName; 
        if (pipeline.SubTask) {
            const subTaskName=pipeline.SubTask.TaskName;
            const subTaskROWID=pipeline.SubTask.SubTaskROWID;
            return `${dealName}/${PipelineName}/${taskName}/${subTaskName}__${dealName}_${pipelineROWID}_${taskROWID}_${subTaskROWID}`;
        } else {
            return `${dealName}/${PipelineName}/${taskName}__${dealName}_${pipelineROWID}_${taskROWID}`;
        } 
      }
      const handleSendEmailFromAccount = async (obj, type, taskROWID,isSchedule) =>{ 
        if (AccountID) {
          setLoader(true);
          let alreadyUploadedAttachments = attachments.filter((e) => !e.file);
          alreadyUploadedAttachments = alreadyUploadedAttachments.map((k) => {
            delete k.attachmentSize;
            k["storeName"] = localStorage.getItem("ZUID");
            return k;
          });
          let attachmentsToBeUploaded = attachments.filter((e) => e.file);
          let attachmentArr = [];
          if (attachmentsToBeUploaded && attachmentsToBeUploaded.length > 0) {
            await UploadAttachments(attachmentsToBeUploaded).then((res) => { 
                if (res.length > 0) {
                  attachmentArr = res.map((k) => {
                    delete k.url;
                    return k;
                  }); }  }).catch((e) => { console.log(e);});
          }
          if ( alreadyUploadedAttachments && alreadyUploadedAttachments.length > 0 ) {
            if (attachmentArr && attachmentArr.length > 0) {
              attachmentArr = [...attachmentArr, ...alreadyUploadedAttachments];
            } else {
              attachmentArr = alreadyUploadedAttachments;
            }
          }
          let attachmentsToBeSend = attachmentArr.filter((e) => e.attachmentPath);
          obj["attachments"] = attachmentsToBeSend;
          console.log("attachmentsssss",obj.attachments);
          
          await EmailService.SendEmail(AccountID, obj).then(async (result) => {
              setOpenSchedulePopup(false);
              let dataObj={TaskROWID:taskROWID,TaskType:type,MessageID:isSchedule?obj?.subject:result.data.messageId,EmailAddress:obj.fromAddress};
              EmailService.saveAutomationManangerRecord(dataObj).then(res=>{
                setLoader(false); 
                setAttachments([]);
              }) 
               let task=createBreadCrumbFromTask(viewTaskData);
                  await EmailService.AssociateEmailWithRecords({
                    messageId:result.data.messageId,
                  AssociationType:"Manual",
                  AssociationObj:{Tasks:[task]}
                },"Post").then(res=>{ 
                  swal("Success!", "Email associated successfully!", "success");
                }).catch(e=>{ 
                  swal("Error!", "Something went wrong while associating email with task!", "error");
                })
                setComposePopup(false); 
            })
            .catch((err) => {
              setLoader(false);
              setAttachments([]);
              swal("Error!", "Something went wrong!", "error");
            });
        }
      }

      const handleSendEmail =async (data, type, taskROWID) =>{  
        try { 
        const uploadPromises = attachments.map(file => customUploadAction(file.file, type, taskROWID));
        const uploadedLinks = await Promise.all(uploadPromises); 
        console.log("uploaded links from the bot account",uploadedLinks);
        
        let obj = {
            fromAddress: data.fromAddress,
            askReceipt: data.askReceipt,
            attachments: uploadedLinks, 
            bccAddress: data.bccAddress,
            ccAddress: data.ccAddress,
            content: data.content,
            mailFormat: "html",
            subject: data.subject,
            toAddress: data.toAddress,
            token:localStorage.getItem('token'),
            backendUrl:Config.backend_url,
            taskType: type,
            taskROWID: taskROWID,
        };
        setLoader(true);
        EmailService.SendEmailFromTasks(obj).then(res=>{
          setLoader(false);
          setRefreshEnable(true);
          setComposePopup(false);
        }).catch(err=>{
          setLoader(false)
        }) 
      } catch (error) {
        setLoader(false);
        console.log("Error Sending Email"); 
      }
      }
      const handleSendButton = async (message, isReply) =>{ 
        if(!_.isArray(composeMailObj?.to) || !composeMailObj?.to?.map((e) => e.email)?.join(",")){
          alert("Please add To address!")
          return
        }
        // const obj = { ...composeObj };
        let type = task?.hasOwnProperty("SubTaskROWID")?"SubTask":"Task";
        let taskROWID = type=="SubTask"?task.SubTaskROWID:task?.TaskROWID;
        const obj = {askReceipt:"yes"};
        obj.fromAddress = composeMailObj?.from?.map((e) => e.email)?.join(",");
        obj.toAddress = composeMailObj?.to?.map((e) => e.email)?.join(",");
        obj.ccAddress = composeMailObj?.cc?.map((e) => e.email)?.join(",");
        obj.bccAddress = composeMailObj?.bcc?.map((e) => e.email)?.join(",");
        obj.content = message;
        obj.mailFormat = "html"; 
        let attachmentsData=[];
        if(obj.fromAddress==task?.TaskFlowObject?.BotAccountEmail){
          if(isReply){ 
            let sub =  composeMailObj?.subject;
            obj.subject = "RE: " + sub;
            handleReplyEmail(obj, type, taskROWID, attachmentsData);
          }else{
            obj.subject = composeMailObj?.subject;
            handleSendEmail(obj, type, taskROWID, attachmentsData);
          }
        }else{
          if(isReply){ 
            let sub =  composeMailObj?.subject;
            obj.subject = "RE: " + sub;
            handleReplyEmailFromAccount(obj, type, taskROWID);
          }else{
            obj.subject = composeMailObj?.subject;
            handleSendEmailFromAccount(obj, type, taskROWID);
          }
      }
    }
    const handleUploadFiles = () => {
        let link = document.createElement('input');
        link.setAttribute('type', 'file');
        link.setAttribute('name', 'uploadFiles');
        link.setAttribute('multiple', "multiple");
        document.body.appendChild(link);
        link.click();
        link.onchange = function (e) { 
          handleFileAttachments(e.currentTarget.files);
        } 
        document.body.removeChild(link);
      }
      function base64ToFile(base64, fileName) {
        const mimeType = getMimeTypeFromFilename(fileName);
        const byteString = atob(base64);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeType });
        const file = new File([blob], fileName, {
          type: mimeType,
          lastModified: Date.now()
        });
        return file;
      }
      const mimeTypeMap = {
        "pdf": "application/pdf",
        "doc": "application/msword",
        "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "xls": "application/vnd.ms-excel",
        "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "ppt": "application/vnd.ms-powerpoint",
        "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "txt": "text/plain",
        "csv": "text/csv",
        "jpg": "image/jpeg",
        "jpeg": "image/jpeg",
        "png": "image/png",
        "gif": "image/gif",
        "zip": "application/zip",
        "rar": "application/vnd.rar" 
      };
      function getMimeTypeFromFilename(filename) {
        const ext = filename.split('.').pop().toLowerCase();
        return mimeTypeMap[ext] || "application/octet-stream";
      }
      const convertBase64AttachmentsToFiles = (attachments) => {
        return attachments.map(att => {
          if (att.compressedBase64 && !att.file) {
            const file = base64ToFile(att.compressedBase64, att.attachmentName);
            return {
              attachmentId: uuid(),
              attachmentName: att.attachmentName,
              file: file
            };
          }
          return att;
        });
      };      
      const getViewEmailData = (viewMaildata, flag) => {  
        setContentShowFlag(flag);
        setReplyEmail(flag !== 'forward'); 
        const formattedBody = () => {
          return (
            `<br><br><br><hr><pre class='forward-content'> 
      From: ${(viewMaildata?.from || []).map((item) => item.email).join("; ")}
      Sent: ${dayjs(viewMaildata?.date).format("MMMM DD, YYYY hh:mm A")}
      To: ${(viewMaildata?.to || []).map((item) => item.email).join("; ")}
      ${(viewMaildata?.cc?.length > 0 ? `Cc: ${(viewMaildata.cc || []).map((item) => item.email).join("; ")}` : "")}
      Subject: ${viewMaildata?.subject}
      </pre>${viewMaildata?.body || ""}`
              .trim()
              .split("\n")
              .filter(line => line.trim().length > 0)
              .join("\n")
          );
        }; 
        const botEmail = task?.TaskFlowObject?.BotAccountEmail; 
        if (flag === 'forward') {
          const obj = {
            to: [],
            cc: [],
            bcc:[],
            from: [{ email: botEmail, id: 0 }],
            subject: "Fwd: " + (viewMaildata?.subject || "")
          };
          setDraftEmailContent(viewMaildata?.body || "");
          setComposeMailObj(obj);
          let attachmentsArr=convertBase64AttachmentsToFiles(viewMaildata?.attachments);
          console.log("attach",attachmentsArr);
          
          setAttachments(attachmentsArr)
        } else {
          const obj = { ...viewMaildata }; 
          obj.from = [{ email: botEmail, id: 0 }];
          obj.bcc = []; 
          if (flag === 'replyemail') {
            obj.to = viewMaildata?.from || [];
            obj.cc = [];
          } else if (flag === 'replyallemail') {
            const isSenderBot = (viewMaildata?.from || []).some(e => e.email === botEmail);
            obj.to = isSenderBot ? (viewMaildata?.to || []) : (viewMaildata?.from || []);
            obj.cc = viewMaildata?.cc || [];
            obj.bcc = viewMaildata?.bcc || [];
          } 
          setDraftEmailContent(formattedBody());
          setComposeMailObj(obj);
        }
      };
      
   
    const items = [
      {
        label: <Tooltip placement='topLeft' title={composeMailObj?.from?.map((e) => e.email)[0]!=userinfo.email_id?'Email scheduling is only available for personal accounts.':''}><a 
        // title={composeMailObj?.from?.map((e) => e.email)[0]!=userinfo.email_id?'Email scheduling is only available for personal accounts.':''}
        style={composeMailObj?.from?.map((e) => e.email)[0]==userinfo.email_id?{cursor:'pointer'}:{cursor:'not-allowed'}}
        onClick={(e)=>{ 
          if(composeMailObj?.from?.map((e) => e.email)[0]!=userinfo.email_id){
             e.preventDefault();
             return
            }
            if(composeMailObj?.to?.length == 0){
              e.preventDefault();
              swal("Alert!", `No recipients added in "To" field`, "warning");
            }else{
              setOpenSchedulePopup(!openSchedulePopup);
              // setIsSchedule(true);
            }
        }}
        >
            Send Later
        </a></Tooltip>,
        key: '1',
      }
    ]
  
  return (
    <div style={{marginTop:'-25px'}}>
      {loader && <Loader/>}
      {openSchedulePopup&&<EmailSchedular openSchedulePopup={openSchedulePopup} setOpenSchedulePopup={setOpenSchedulePopup} emailContent={emailContent} composeMailObj={composeMailObj} handleSendEmail={(obj)=>{
       let type = task?.hasOwnProperty("SubTaskROWID")?"SubTask":"Task";
       let taskROWID = type=="SubTask"?task.SubTaskROWID:task?.TaskROWID;
        handleSendEmailFromAccount(obj,type,taskROWID,true)}}/>}
                  {viewEmail && contentShowFlag == "viewemail" ?
      <div class="mail-view bg-white">  
            <div class="message-body">
              <div className="custom_email_header"> 
                      <Row sm={12} style={{
                        "margin": "3px 0px !important",
                        "display": "flex",
                        "align-items": "center"
                      }}>
                      <Col sm={9}>
                        <p
                          style={{
                            "font-size": "1.4rem",
                            "font-weight": 500,
                            "color": "#5b6c97",
                          }}
                          // onClick={(e) => handleNotificationHyperlink(e)}
                          className="notifications-hyperlinks my-1"
                          dangerouslySetInnerHTML={{
                            __html: viewEmail?.subject,
                          }}
                        ></p>
                      </Col>
                        <Col sm={3}>
                          <div class="row">   
                              <div class="btn-toolbar"  style={{position:"relative"}}> 
                                <div class="btn-group">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      getViewEmailData(viewEmail, "replyemail"); 
                                    }}
                                    class="btn btn-sm btn-outline-secondary"
                                  >
                                    <i class="mdi mdi-reply text-primary mr-1"></i>{" "}
                                    Reply
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      getViewEmailData(viewEmail, "replyallemail"); 
                                    }}
                                    class="btn btn-sm btn-outline-secondary"
                                  >
                                    <i class="mdi mdi-reply-all text-primary mr-1"></i>
                                    Reply All
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary"
                                    onClick={() => {
                                      getViewEmailData(viewEmail, "forward");
                                    }}
                                  >
                                    <i class="mdi mdi-share text-primary mr-1"></i>
                                    Forward
                                  </button>
                                </div> 
                            </div>
                          </div>
                        </Col> 
                      </Row> 
                <div style={{display: 'flex',flexDirection: 'row'}}>
                  <span class="no-image-icon img-sm rounded-circle mr-3">
                    {viewEmail && viewEmail?.from
                      ? viewEmail?.from.map(e=>e.email)[0].charAt(0).toUpperCase()
                      : ""}
                  </span>
                  <div class="details"> 
                      <p class="sender-email mb-0" style={{position:"relative"}}>
                        <a href="#" onClick={(e) => e.preventDefault()} style={{ fontSize: "1.2rem" }}>{composeMailToShow.from}</a>
                      </p>
                    {(composeMailToShow.to).length > 0 &&
                    <p class="sender-email mb-0">To: &nbsp;&nbsp;
                      <a href="#" onClick={(e) => e.preventDefault()}>{(composeMailToShow.to).map((item)=>{
                       return item.email + "; "
                      })}</a>
                      &nbsp; 
                    </p>
                    }
                    {(composeMailToShow.cc).length > 0 && 
                    <p class="sender-email mb-0">Cc: &nbsp;&nbsp;
                      <a href="#" onClick={(e) => e.preventDefault()}>{(composeMailToShow.cc).map((item)=>{
                       return item.email + "; "
                      })}</a>
                      &nbsp; 
                    </p>
                    }
                    <p class="msg-subject mb-0" style={{
                      "font-size": "small",
                      "font-style": "italic",
                    }}>
                      {dayjs(viewEmail?.date).format("MMMM DD, YYYY hh:mm A")}
                    </p> 
                  </div>
                </div>
                  {emailAttachmentInfo && <Row> {attachementLoader?<div style={{margin:'15px'}}><Spin size="small" /> Getting attachments ready ...
          </div>:<PreviewAndDownload attachments={emailAttachmentInfo} getIconByType={getIconByType}/>}</Row>}
              </div>

              <div
                class="message-content"
                style={{ height: "77%" }}
              >
               
                                <div
                    dangerouslySetInnerHTML={{
                      __html: viewEmail?.body
                        ?.replaceAll('<table', '<table style="width:100%; border-collapse:collapse; margin-top:1em;"')
                        ?.replaceAll('<td>', '<td style="border:1px solid #ccc; padding:8px; text-align:left;">')
                        ?.replaceAll('<th>', '<th style="border:1px solid #ccc; padding:8px; text-align:left;">')
                        ?.replaceAll('<h1>', '<h1 style="margin: 0.5em 0;">')
                        ?.replaceAll('<h2>', '<h2 style="margin: 0.5em 0;">')
                        ?.replaceAll('<h3>', '<h3 style="margin: 0.5em 0;">')
                    }}
                  ></div> 
              </div>
            </div>
            </div> 
            :
            <ComposeEmail 
                  isReply={(contentShowFlag=='replyemail'||contentShowFlag=='replyallemail')?
                    true:contentShowFlag=='forward'?false:undefined}
                  isForward={contentShowFlag=='forward'?true:false}
                  viewEmail={viewEmail} 
                  handleFileAttachments={handleFileAttachments}
                  setIsDraftAlready={setIsDraftAlready}
                  items={items}
                  showCC={showCC}
                  task={task}
                  fromtask={fromtask}
                  showBCC={showBCC}
                  userinfo={userinfo}
                  getCCOptions={getCCOptions}
                  emailContent={emailContent}
                  handleSendButton={handleSendButton}
                  handleSaveDraft={()=>{}}
                  handleUploadFiles={handleUploadFiles}
                  attachments={attachments}
                  setComposeMailObj={setComposeMailObj}
                  composeMailObj={composeMailObj}
                  allUsers={allUsers}
                  setEmailContent={setEmailContent}
                  contentShowFlag={contentShowFlag}
                  setViewEmail={setViewEmail}
                  setReplyEmail={setReplyEmail}
                  setContentShowFlag={setContentShowFlag}
                  setShowCC={setShowCC} 
                  setShowBCC={setShowBCC}
                  setAttachments={setAttachments}
                  signature={signature}
                  isSchedule={false} 
                  draftEmailContent={draftEmailContent}
                  setIsSchedule={()=>{}}
                  composeMailToShow={composeMailToShow}
                  openSchedulePopup={false}
                  setOpenSchedulePopup={setOpenSchedulePopup}  
                  handleNotificationHyperlink={handleNotificationHyperlink}
    />
    }</div>
  )
}
